import { Suspense, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Routes, Route, HashRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { CustomNotification } from "../CustomNotification/CustomNotification";
import { RutaPrivada } from "Rutas/RutaPrivada";
import { RutaAdminLogin } from "Rutas/RutaAdminLogin";
import { RutaPublica } from "Rutas/RutaPublica";
import { storageService } from "Services/storage_service";
import { setAuthUser } from "Slices/Login/loginSlice";
import { useTokenExpiration } from "Hooks/useTokenExpiration";
import { useNotificationTimer } from "Hooks/useNotificationTimer";
import RutaInicio from "Rutas/RutaInicio";
import Principal from "Pages/Principal/Principal";
import DashboardAdmin from "Pages/Dashboard/Administrador/Index";
import { MisCursos } from "Pages/MisCursos/MisCursos";
import { MisPaquetesDeCursos } from "Pages/MisPaquetesDeCursos/MisPaquetesDeCursos";
import { Misfavoritos } from "Pages/Misfavoritos/Misfavoritos";
import { CapacitacionesPresenciales } from "Pages/CapacitacionesPresenciales/CapacitacionesPresenciales";
import { Usuario } from "Pages/Usuario/Usuario";
import { AdminLogin } from "Pages/AdminLogin/AdminLogin";
import { MenuDrawer } from "Components/MenuDrawer/MenuDrawer";
import { MenuModal } from "Components/MenuModal/MenuModal";
import { Curso } from "Pages/Curso/Curso";
import { CursoPaquete } from "Pages/CursoPaquete/CursoPaquete";
import { Diploma } from "Pages/Diploma/Diploma";
import { RUTAS } from "rutas";
import { Paquete } from "Pages/Paquete/Paquete";
import "./App.css";
import "scss/style.scss";

function App() {
  const dispatch = useDispatch();
  const { startTokenTimer, clearTimer } = useTokenExpiration();
  const { startNotificationTimer, clearNotificationTimer } =
    useNotificationTimer();

  useEffect(() => {
    const cookieUser = storageService.getItem("user");
    if (cookieUser?.idUsuario > 0) {
      startTokenTimer(cookieUser);
      startNotificationTimer();
      dispatch(setAuthUser(cookieUser));
      return;
    }

    const sessionUser = sessionStorage.getItem("user");
    if (sessionUser) {
      const parsedSessionUser = JSON.parse(sessionUser);
      startTokenTimer(parsedSessionUser);
      startNotificationTimer();
      dispatch(setAuthUser(parsedSessionUser));
    }

    return () => {
      clearTimer();
      clearNotificationTimer();
    };
  }, []);

  return (
    <SnackbarProvider
      maxSnack={5}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      autoHideDuration={5000}
      Components={{
        default: CustomNotification,
        notification: CustomNotification,
      }}
    >
      <HashRouter>
        <Suspense
          fallback={
            <div className="text-center">
              {/* <h3 className="me-2">Cargando</h3> */}
              {/* <Loader/> */}
            </div>
          }
        >
          <Routes>
            <Route
              exact
              path={RUTAS.PRINCIPAL}
              element={
                <RutaInicio>
                  <Principal />
                </RutaInicio>
              }
            />

            <Route
              path={RUTAS.MIS_CURSOS}
              element={
                <RutaPrivada>
                  <MisCursos />
                </RutaPrivada>
              }
            />

            <Route
              path={RUTAS.MIS_PAQUETES}
              element={
                <RutaPrivada>
                  <MisPaquetesDeCursos />
                </RutaPrivada>
              }
            />

            <Route
              path={RUTAS.MIS_FAVORITOS}
              element={
                <RutaPrivada>
                  <Misfavoritos />
                </RutaPrivada>
              }
            />

            <Route
              path={RUTAS.MIS_CAPACITACIONES_PRESENCIALES}
              element={
                <RutaPrivada>
                  <CapacitacionesPresenciales />
                </RutaPrivada>
              }
            />

            <Route
              path={RUTAS.MI_USUARIO}
              element={
                <RutaPrivada>
                  <Usuario />
                </RutaPrivada>
              }
            />

            <Route
              path={RUTAS.ADMIN_LOGIN}
              element={
                <RutaAdminLogin>
                  <AdminLogin />
                </RutaAdminLogin>
              }
            />

            <Route
              path={RUTAS.CURSO_PATH}
              element={
                <RutaPublica>
                  <Curso />
                </RutaPublica>
              }
            />

            <Route
              path={RUTAS.DIPLOMA_CURSO_PATH}
              element={
                <RutaPublica>
                  <Diploma />
                </RutaPublica>
              }
            />

            <Route
              path={RUTAS.PAQUETE_PATH}
              element={
                <RutaPublica>
                  <Paquete />
                </RutaPublica>
              }
            />

            <Route
              path={RUTAS.PAQUETE_CURSO_PATH}
              element={
                <RutaPublica>
                  <CursoPaquete />
                </RutaPublica>
              }
            />

            <Route
              path={RUTAS.DIPLOMA_PAQUETE_PATH}
              element={
                <RutaPublica>
                  <Diploma />
                </RutaPublica>
              }
            />

            <Route
              exact
              path="*"
              element={
                <RutaPrivada>
                  <DashboardAdmin />
                </RutaPrivada>
              }
            />
          </Routes>
          <MenuDrawer />
          <MenuModal />
        </Suspense>
      </HashRouter>
    </SnackbarProvider>
  );
}

export default App;
